/* eslint-disable no-lone-blocks */
import React, { useState } from "react";
import { Button, Form, Spinner, Alert } from 'react-bootstrap';

import '../styling/stripe.css'


import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

import AccountActivationPanel from '../components/AccountActivationPanel';
 
// From "https://github.com/yosriady/serverless-stripe-frontend/blob/master/components/PayButton.js"
import config from '../stripe_config.js';
import XenkiaAWSconfig from '../config.js'

import carte_bancaire from '../icons/bankscards/carte-bancaire-480x300.png'
import master_card from '../icons/bankscards/icons8-mastercard-96.png'
import visa_card from '../icons/bankscards/icons8-visa-96.png'
import jcb_card from '../icons/bankscards/icons8-jcb-96.png'
import amex_card from '../icons/bankscards/icons8-american-express-96.png'


// Make sure to call `loadStripe` outside of a component’s render to avoid recreating the `Stripe` object on every render.
const stripePromise = loadStripe(config.stripe.apiKey);




// Stripe form Rendering and Payment processing.
function StripeProcessing(props){

    return(
        <div>
            <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
                <StripeForm
                  processPayment        = {props.processPayment}
                  userInfo              = {props.userInfo}
                  initialPackage        = {props.initialPackage}
                  packageInfo           = {props.packageInfo}
                  onBack                = {props.onBack}
                  onPaymentSuccess      = {props.onPaymentSuccess}
                />
            </Elements>

        </div>
    )
}



// Stripe Form.
function StripeForm(props){

    const stripe                                                = useStripe();
    const elements                                              = useElements();
    const [error, setError]                                     = useState(null);
    const [cardComplete, setCardComplete]                       = useState(false);
    const [processing, setProcessing]                           = useState(false);
    const [paymentSuccesful, setPaymentSuccesful]               = useState(false);
    
    const [paymentProcessingError, setPaymentProcessingError]   = useState(false);
    const [paymentErrorMsg, setPaymentErrorMsg]                 = useState("");

    const [discountCoupon, setDiscountCoupon]                   = useState("");
    const [verifyingDiscountCoupon, setVerifyingDiscountCoupon] = useState(false);
    const [discountPercentage, setDiscountPercentage]           = useState({
      discountPercentage:   0.0,
      verified:             false
    });
    const [couponMessage, setCouponMessage]                     = useState('');
    const [invalidCoupon, setInvalidCoupon]                     = useState(false);
    const [verifyButtonDisabled, setVerifyButtonDisabled]       = useState(true);
    const selectedPackage = props.initialPackage || {
      accountType: 'Individual',
      pricingPlan: 'Starter',
      billingCycle: 'Monthly'
    };
    const retrievedPkgInfo = props.packageInfo || {
      packageCost: 0,
      discount: 0,
      features: [],
      gettingPackageInfo: false,
      error: ''
    };
    const yearlyDiscount = {
      applicable: selectedPackage.billingCycle === 'Yearly' && Number(retrievedPkgInfo.discount) > 0,
      percentage: Number(retrievedPkgInfo.discount) || 0
    };
    const couponDiscountMultiplier = discountPercentage.verified
      ? 1 - Number(discountPercentage.discountPercentage) / 100
      : 1;
    const annualDiscountMultiplier = yearlyDiscount.applicable
      ? 1 - yearlyDiscount.percentage / 100
      : 1;
    const payableAmount = (Number(retrievedPkgInfo.packageCost) * annualDiscountMultiplier * couponDiscountMultiplier).toFixed(2);
    const discountedPackageCost = (
      Number(retrievedPkgInfo.packageCost) * (1 - yearlyDiscount.percentage / 100)
    ).toFixed(2);



    //console.log(props.userInfo);

    /**
     * Process the payment based on the TOKEN generated by Stripe and then Proceed with User Registration if it was a success.
     * @param {*} token 
     */
    const onToken = async (token) => {// 'token' returned from Stripe.
        const submittedUserInfo = { ...props.userInfo };
        delete submittedUserInfo.accountType;
        try {
        const res = await fetch(config.stripe.apiUrl, {
            method: 'POST',
            body: JSON.stringify({
              token,
              userInfo: submittedUserInfo,
              accountInfo: {
                accountType: selectedPackage.accountType,
                pricingPlan: selectedPackage.pricingPlan,
                billingCycle: selectedPackage.billingCycle
              },
              discountToken: discountCoupon
            })
          });
          const response = await res.json();
          const result = response.body || response;
          if (!res.ok || String(result.status || '').toLowerCase() === 'error') {
            throw new Error(result.error || result.message || 'Payment could not be completed. Please try again.');
          }
          return result;
        } catch (requestError) {
          return { status: 'error', error: requestError.message || 'Payment could not be completed. Please try again.' };
        }
    }


    /**
     * This function will reset the card.
     */
    const resetCardDetails = () => {
        setError(null);
        setProcessing(false);
      };



    /**
     * What to do when the Submit button is pressed.
     */
    const HandleSubmit = async (event) => {
      // We don't want to let default form submission happen here,
      // which would refresh the page.
      event.preventDefault();

      //console.log(props.userInfo.pricingPlan.toLowerCase());
  
      if (!stripe || !elements) {
        // Stripe.js has not loaded yet. Make sure to disable
        // form submission until Stripe.js has loaded.
        return;
      }
  
      if (error) {
        elements.getElement("card").focus();
        return;
      }
  
      if (!config.stripe.apiUrl) {
        setPaymentErrorMsg('Payment processing is temporarily unavailable. Please try again later.');
        setPaymentProcessingError(true);
        return;
      }

      setPaymentProcessingError(false);
      setPaymentErrorMsg('');
      setError(null);
      setProcessing(true);
  
      const card = elements.getElement(CardElement);
      const result = await stripe.createToken(card).catch(tokenError => ({
        error: { message: tokenError.message || 'Card details could not be verified. Please try again.' }
      }));

      if (result.error) {
        setError(result.error);
        setProcessing(false);
      }
      else {
        // Show error to your customer.
        //console.log(result.error.message);
        
        //console.log("SUCCESS: Token generated");

        // Now send the TOKEN to the server and make the payment.
        {
          let retPayment;

          //console.log(result.token);
          retPayment = await onToken(result.token);

          const paymentStatus = String(retPayment.status || '').toLowerCase();
          if(paymentStatus === "error")
          {
            //console.log("ERROR: ", retPayment.error);

            // Show Alert() message.
            setPaymentErrorMsg(retPayment.error);
            setPaymentProcessingError(true);
            setProcessing(false);
          }
          else if (paymentStatus === "success")
          {
            //console.log("SUCCESS: ", retPayment.message);

            // Mark that the payment was successful.
            setPaymentSuccesful(true);
            props.onPaymentSuccess?.();

            // Reset the Payment details.
            resetCardDetails();
          } else {
            setPaymentErrorMsg('Payment could not be completed. Please try again.');
            setPaymentProcessingError(true);
            setProcessing(false);
          }
        }
      }
    }



    const SubmitButton = ({ processing, error, children, disabled }) => (
      <div className="signup-payment-submit-wrap">
        <Button
          className={`SubmitButton signup-payment-submit-button ${error ? "SubmitButton--error" : ""}`}
          type="submit"
          disabled={processing || disabled || !cardComplete}
        >
          <span className="signup-payment-submit-content">{children}</span>
        </Button>
      </div>
    );

  const verifyCoupon = async () => {
    if (!XenkiaAWSconfig.discount.verifyCoupon) {
      setInvalidCoupon(true);
      setCouponMessage('Coupon verification is temporarily unavailable.');
      return;
    }
    setVerifyingDiscountCoupon(true);
    setCouponMessage('');
    try {
      const res = await fetch(XenkiaAWSconfig.discount.verifyCoupon, {
        method: 'POST',
        body: JSON.stringify({ token: discountCoupon.trim() })
      });
      const response = await res.json();
      const result = response.body || response;
      if (res.ok && response.statusCode === 202) {
        setDiscountPercentage({ verified: true, discountPercentage: Number(result.discountPercentage) || 0 });
        setInvalidCoupon(false);
        setCouponMessage('Coupon applied.');
      } else {
        setDiscountPercentage({ verified: false, discountPercentage: 0 });
        setInvalidCoupon(true);
        setCouponMessage(result.msg || 'That coupon code could not be applied.');
      }
    } catch (requestError) {
      setDiscountPercentage({ verified: false, discountPercentage: 0 });
      setInvalidCoupon(true);
      setCouponMessage(requestError.message || 'Could not verify the coupon. Please try again.');
    } finally {
      setVerifyingDiscountCoupon(false);
    }
  };








  return(
    <div className="signup-stripe-page">
      {props.userInfo !== null
      ?
          <div className="signup-stripe-content">
            {paymentSuccesful
              ?
                <AccountActivationPanel email={props.userInfo.email} eyebrow="PAYMENT CONFIRMED" title="Payment successful" subtitle="Your payment is complete. Activate your account to finish setting it up." />
              :
                <>
                  <div className="signup-step-heading">
                    <Button className="signup-back-button signup-flow-return" type="button" onClick={props.onBack} aria-label="Back to your details" title="Back to your details">
                      <svg className="signup-return-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                        <path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z" />
                      </svg>
                    </Button>
                    <div>
                      <h2>Payment</h2>
                      <p>Your details and plan are ready. Add payment details to complete signup.</p>
                    </div>
                  </div>

                  <div className="signup-payment-summary">
                    <div>
                      <span>{selectedPackage.accountType} · {selectedPackage.billingCycle}</span>
                      <strong>{selectedPackage.pricingPlan}</strong>
                    </div>
                    <div className="signup-payment-summary-price">
                      {retrievedPkgInfo.gettingPackageInfo
                        ? <Spinner animation="border" size="sm" aria-label="Loading plan price" />
                        : yearlyDiscount.applicable
                          ? <>
                              <s className="signup-payment-summary-original">${retrievedPkgInfo.packageCost}</s>
                              <strong>${discountedPackageCost} USD</strong>
                            </>
                          : `$${retrievedPkgInfo.packageCost} USD`}
                      <span> / {selectedPackage.billingCycle.toLowerCase()}</span>
                    </div>
                  </div>
                  {retrievedPkgInfo.error && <Alert variant="warning" className="signup-form-alert">{retrievedPkgInfo.error}</Alert>}

                  <h3 className="signup-payment-heading">Payment details</h3>
                  <div>
                    <form className="Form" onSubmit={HandleSubmit}>
                      {paymentProcessingError && (
                        <Alert className="signup-form-alert signup-payment-error" variant="danger" role="alert">
                          <Alert.Heading>We could not confirm that payment.</Alert.Heading>
                          <p>{paymentErrorMsg}</p>
                          <p className="mb-0">Your details are still here. If you submitted the payment before a connection error, check your card activity before retrying.</p>
                        </Alert>
                      )}

                            <div className="signup-payment-card">
                              <div className="signup-payment-panel">
                                <fieldset className="FormGroup signup-card-field">
                                  <CardField
                                    onChange={(e) => {
                                      setError(e.error);
                                      setCardComplete(e.complete);
                                    }}
                                  />
                                </fieldset>
                                <div className="signup-card-brands" aria-label="Accepted card brands">
                                  <img src={master_card} alt="Mastercard" height="32" />
                                  <img src={visa_card} alt="Visa" height="32" />
                                  <img src={amex_card} alt="American Express" height="32" />
                                  <img src={jcb_card} alt="JCB" height="32" />
                                  <img className="signup-card-brand-cb" src={carte_bancaire} alt="Carte Bancaire" width="54" height="34" />
                                </div>
                                <p className="signup-payment-note signup-review-note"><span><b>Note:</b> The ZIP code should match the billing address registered with your card.</span></p>
                              </div>

                              <div className="signup-coupon-section">
                                <label htmlFor="discount-coupon-textbox">Discount code</label>
                                <div className="signup-coupon-form">
                                  <Form.Control
                                    id="discount-coupon-textbox"
                                    type="text"
                                    placeholder="Enter coupon code"
                                    name="discountCoupon"
                                    value={discountCoupon}
                                    autoComplete="off"
                                    onChange={(e) => {
                                      setDiscountCoupon(e.target.value);
                                      if(e.target.value.trim().length > 0) setVerifyButtonDisabled(false);
                                      else setVerifyButtonDisabled(true);

                                      // This is to make sure that if the user changes/deletes the coupon after verification, it won't show that the discount was applied, when it actualy wasn't.
                                      setDiscountPercentage({verified: false, discountPercentage: 0});
                                      setInvalidCoupon(false);
                                      setCouponMessage('');
                                    }}
                                  />
                                  <Button id="coupon-verify-button" type="button" variant="outline-success" disabled={verifyButtonDisabled || verifyingDiscountCoupon || !XenkiaAWSconfig.discount.verifyCoupon} onClick={verifyCoupon}>
                                    {verifyingDiscountCoupon
                                      ? <Spinner animation="border" variant="success" style={{fontSize: '1rem'}}/>
                                      : <>Apply</>}
                                  </Button>
                                  {couponMessage && <span className={`signup-coupon-message${invalidCoupon ? ' is-error' : ''}`} role="status">{couponMessage}</span>}
                                  {!XenkiaAWSconfig.discount.verifyCoupon && <span className="signup-coupon-message">Coupon verification is temporarily unavailable.</span>}
                                </div>
                              </div>
                            </div>

                            <div className="signup-payment-action">
                              {error && <ErrorMessage>{error.message}</ErrorMessage>}
                              <SubmitButton processing={processing} error={error} disabled={!stripe || !config.stripe.apiUrl || retrievedPkgInfo.gettingPackageInfo || Boolean(retrievedPkgInfo.error)}>
                                  {paymentProcessingError ? 'Retry payment' : 'Pay'}
                                  {!retrievedPkgInfo.gettingPackageInfo ? (
                                    <span className="signup-payment-total">
                                      {(yearlyDiscount.applicable || discountPercentage.verified) && (
                                        <s>${Number(retrievedPkgInfo.packageCost).toFixed(2)}</s>
                                      )}
                                      <b>${payableAmount} USD</b>
                                    </span>
                                  ) : (
                                    <Spinner animation="border" size="sm" />
                                  )}
                              </SubmitButton>
                            </div>
                        </form>
                      </div>
                </>
            }
          </div>
        :
          <div>
            <p style={{fontSize: '200%'}}>Loading...</p>
          </div>
        }
    </div>
    );
  }






const ELEMENTS_OPTIONS = {
    fonts: [
      {
        cssSrc: "https://fonts.googleapis.com/css?family=Roboto"
      }
    ]
  };

const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
      base: {
        iconColor: "#5c91b6",
        color: "#21364a",
        fontWeight: 500,
        fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
        fontSize: "16px",
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: "#fce883"
        },
        "::placeholder": {
          color: "#8293a3"
        }
      },
      invalid: {
        iconColor: "#bd5050",
        color: "#bd5050"
      }
    }
  };


  const CardField = ({ onChange }) => (
    <div className="FormRow">
      <CardElement options={CARD_OPTIONS} onChange={onChange} />
    </div>
  );
  
  const Field = ({
    label,
    id,
    type,
    placeholder,
    required,
    autoComplete,
    value,
    onChange
  }) => (
    <div className="FormRow">
      <label htmlFor={id} className="FormRowLabel">
        {label}
      </label>
      <input
        className="FormRowInput"
        id={id}
        type={type}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
      />
    </div>
  );
  
  
  const ErrorMessage = ({ children }) => (
    <div className="ErrorMessage" role="alert">
      <svg width="16" height="16" viewBox="0 0 17 17">
        <path
          fill="#FFF"
          d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
        />
        <path
          fill="#6772e5"
          d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
        />
      </svg>
      {children}
    </div>
  );
  
  const ResetButton = ({ onClick }) => (
    <button type="button" className="ResetButton" onClick={onClick}>
      <svg width="32px" height="32px" viewBox="0 0 32 32">
        <path
          fill="#FFF"
          d="M15,7.05492878 C10.5000495,7.55237307 7,11.3674463 7,16 C7,20.9705627 11.0294373,25 16,25 C20.9705627,25 25,20.9705627 25,16 C25,15.3627484 24.4834055,14.8461538 23.8461538,14.8461538 C23.2089022,14.8461538 22.6923077,15.3627484 22.6923077,16 C22.6923077,19.6960595 19.6960595,22.6923077 16,22.6923077 C12.3039405,22.6923077 9.30769231,19.6960595 9.30769231,16 C9.30769231,12.3039405 12.3039405,9.30769231 16,9.30769231 L16,12.0841673 C16,12.1800431 16.0275652,12.2738974 16.0794108,12.354546 C16.2287368,12.5868311 16.5380938,12.6540826 16.7703788,12.5047565 L22.3457501,8.92058924 L22.3457501,8.92058924 C22.4060014,8.88185624 22.4572275,8.83063012 22.4959605,8.7703788 C22.6452866,8.53809377 22.5780351,8.22873685 22.3457501,8.07941076 L22.3457501,8.07941076 L16.7703788,4.49524351 C16.6897301,4.44339794 16.5958758,4.41583275 16.5,4.41583275 C16.2238576,4.41583275 16,4.63969037 16,4.91583275 L16,7 L15,7 L15,7.05492878 Z M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z"
        />
      </svg>
    </button>
  );



export default StripeProcessing;
